import * as tslib_1 from "tslib";
import { ApiLoadingService } from "./api-loading.service";
import { ApiCallService } from "./api-call.service";
import { HttpClient } from "@angular/common/http";
import { LocaleService } from "../seo/locale.service";
export class BlocksService {
    constructor(apiLoadingService, apiCallService, httpClient, localeService) {
        this.apiLoadingService = apiLoadingService;
        this.apiCallService = apiCallService;
        this.httpClient = httpClient;
        this.localeService = localeService;
    }
    getBlocks(category, fetchLocalData = false) {
        return fetchLocalData
            ? this.fetchLocalData(`../../../assets/data/blocks/${category}.json`)
            : this.apiCallService.get(`/block_categories/${category}/blocks`);
    }
    fetchLocalData(path) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.httpClient.get(`../../../${path}`).toPromise();
        });
    }
    resolve(route, state) {
        let promise;
        const categories = route.data["blocks_categories"];
        const localeDataPath = route.data["localeDataPath"];
        if (localeDataPath) {
            let path = localeDataPath;
            if (route.data["hasMultipleTranslations"]) {
                path = `${path}_${this.localeService.getCurrentLocale()}.json`;
            }
            else {
                path = `${path}.json`;
            }
            return this.fetchLocalData(path);
        }
        if (categories.length > 1) {
            const all = [];
            categories.forEach((category) => {
                all.push(this.getBlocks(category));
            });
            promise = Promise.all(all);
        }
        else {
            promise = this.getBlocks(categories[0]);
        }
        this.apiLoadingService.startLoading(promise);
        return promise;
    }
}
